import React from "react";
import { connect } from "react-redux";
import AlertTypeBadge from "~/utils/components/alert_type_badge";
import * as notification from "../redux";

const NotificationAlertBadge = ({ activeAlert, openViewer }) => {
    if (!activeAlert) return null;

    return (
        <AlertTypeBadge
            type={activeAlert.type || activeAlert.level}
            label={activeAlert.title}
            size="lg"
            variant="soft"
            style={{ cursor: "pointer" }}
            onClick={openViewer}
        />
    );
};

const mapStateToProps = store => ({
    activeAlert: notification.selectors.selectActiveAlert(store)
});

const mapDispatchToProps = dispatch => ({
    openViewer: () => dispatch(notification.actions.openAlertViewer())
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationAlertBadge);
